<template>
  <app-header></app-header>
  <section class="catalog history-review">
    <div class="title-box">
      <h1 class="title">{{ $t('history-review.key001') }}</h1>
    </div>
    <div class="products-list">
      <div class="product-item" v-for="item in historyProducts" :key="item.id">
        <div class="product-info" @click="viewProduct(item.eventRoute)">
          <img :src="item.image" alt="" class="" />
          <div class="tag-container">
            <div v-for="(tag, index) in item.tags" :key="index" class="ticket-tag">
              {{ tag }}
            </div>
          </div>
          <div class="text-info">
            <div class="time">
              <p>
                <i class="bi bi-calendar-week"></i>
                <span>{{ item.time }}</span>
              </p>
            </div>
            <div class="text">
              <h2 class="title" :title="item.name">
                {{ item.name }}
              </h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <app-footer></app-footer>
</template>
<script>
import AppHeader from '@/components/Header.vue';
import AppFooter from '@/components/Footer.vue';
import { historyProducts } from '@/api/infoSerivce.js';
import { formatTimeRange } from '@/utils/formatTimeRange';

export default {
  name: 'history-review',
  components: {
    'app-header': AppHeader,
    'app-footer': AppFooter,
  },
  mounted() {
    this.fetchHistoryProducts();
  },
  data() {
    return {
      historyProducts: [],
    };
  },
  props: {},
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    },
  },
  methods: {
    async fetchHistoryProducts() {
      try {
        this.loading = true;
        const langSetting = this.currentLanguage === 'zh_tw' ? 'zh-tw' : this.currentLanguage;
        const response = await historyProducts(langSetting);
        this.historyProducts = response.data.data;
        const historyProductsData = this.historyProducts;
        if (historyProductsData) {
          historyProductsData.forEach((item) => {
            if (item.startTime && item.endTime) {
              item.time = formatTimeRange(item.startTime, item.endTime, true);
            }
          });
        }
      } catch (error) {
        console.error('Error fetching products:', error);
      } finally {
        this.loading = false;
      }
    },
    viewProduct(eventRoute) {
      this.$router.push({
        path: `/${this.currentLanguage}/history-review-detail`,
        query: {
          eventRoute: eventRoute,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.product-info {
  position: relative;

  .tag-container {
    position: absolute;
    top: 8px;
    right: 8px;
    display: flex;
    flex-direction: row-reverse;
    gap: 6px;
  }

  .ticket-tag {
    position: relative;
    padding: 4px 10px;
    font-size: 12px;
    font-weight: 450;
    color: #fff;
    border-radius: 12px;
    background: #a14abfb3;
  }
}
</style>
